__turbopack_context__.v({
  "BorderContainer": "MSBimW_BorderContainer",
  "Date": "MSBimW_Date",
  "DayOfWeek": "MSBimW_DayOfWeek",
  "Month": "MSBimW_Month",
  "ProgramDateButton": "MSBimW_ProgramDateButton",
  "ThemeDk": "MSBimW_ThemeDk",
  "isSelected": "MSBimW_isSelected",
});
